/**
 * https://decipher.dev/30-seconds-of-typescript/docs/pick
 *
 * ```
 * pick({ a: 1, b: "2", c: 3 }, ["a", "c"]); // { 'a': 1, 'c': 3 }
 * ```
 */
var pick = function (obj, arr) {
    return arr.reduce(function (acc, curr) {
        // (curr in obj && (acc[curr] = obj[curr]), acc)
        if (curr in obj) {
            acc[curr] = obj[curr];
        }
        return acc;
    }, {});
};
export default pick;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGljay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb3JlL3V0aWxzL2xvZGFzaC9waWNrLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBOzs7Ozs7R0FNRztBQUNILElBQU0sSUFBSSxHQUFHLFVBQ1gsR0FBTSxFQUNOLEdBQU07SUFFTixPQUFBLEdBQUcsQ0FBQyxNQUFNLENBQUMsVUFBQyxHQUFHLEVBQUUsSUFBSTtRQUNuQixnREFBZ0Q7UUFDaEQsSUFBSSxJQUFJLElBQUksR0FBRyxFQUFFO1lBQ2YsR0FBRyxDQUFDLElBQUksQ0FBQyxHQUFHLEdBQUcsQ0FBQyxJQUFJLENBQUMsQ0FBQztTQUN2QjtRQUNELE9BQU8sR0FBRyxDQUFDO0lBQ2IsQ0FBQyxFQUFFLEVBQVMsQ0FBQztBQU5iLENBTWEsQ0FBQztBQUVoQixlQUFlLElBQUksQ0FBQyJ9